import {Component, EventEmitter, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {SliderComponent} from "../slider/slider.component";
import {NumberChangerComponent} from "../number-changer/number-changer.component";

@Component({
    selector: 'app-slider-with-number',
    templateUrl: './slider-with-number.component.html',
    styleUrl: './slider-with-number.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SliderWithNumberComponent {
  @ViewChild(SliderComponent) slider?: SliderComponent
  @ViewChild(NumberChangerComponent) number?: NumberChangerComponent
  @Output() change = new EventEmitter<number>()

  onSliderChange(value: number) {
    this.change.emit(value)
  }

  onNumberChange(value: number) {
    this.change.emit(value)
  }

  setValue(value: number) {
    this.slider?.setPercent(value, false)
    this.number?.setValue(value)
  }
}
